<template>
  <div class="footer">
    <router-link class="nav" v-for="(v, k) in navs" :key="k" :to="v.url">
      <div class="icon">
        <icon-font :type="v.icon" />
      </div>
      <div class="title">{{v.title}}</div>
    </router-link>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    title: String
  },
  setup () {
    return {
      navs: [
        {
          title: '预约',
          icon: 'icon-yuyue',
          url: '/customer/index'
        },
        {
          title: '我的',
          icon: 'icon-wode',
          url: '/customer/my'
        }
      ]
    }
  }
})
</script>

<style lang="less" scoped>
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1rem;
  z-index: 2;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  .nav {
    color: #333;
    font-size: 0.4rem;
    width: 50%;
    .icon{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 0.6rem;
    }
    .title{
      font-size: 0.2rem;
      line-height: 0.3rem;
      text-align: center;
    }
    &.router-link-active{
      color: #ceb175;
    }
  }
}
</style>
